import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { AerationBasinNodeModel } from './AerationBasinNodeModel';
import { AerationBasinNodeWidget } from './AerationBasinNodeWidget';

export class AerationBasinNodeFactory extends AbstractReactFactory {
  isMainMap: boolean;

  constructor(isMainMap: boolean) {
    super(NodeModelTypeEnum.AerationBasin);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new AerationBasinNodeModel();
  }

  nodeUI(event) {
    return <AerationBasinNodeWidget engine={this.engine} node={event.model} width={206} height={186} renderedOnMap />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
